module.exports = __webpack_public_path__ + "static/vwhead-bolditalic-71bcd5b20798ef487f8661031387f21d.woff2";